export const USERNAME_CACHE_KEY = 'login.username';

const logger = console;

export const getUsername = () => {
  try {
    return localStorage.getItem(USERNAME_CACHE_KEY) !== null
      ? atob(localStorage.getItem(USERNAME_CACHE_KEY) as string)
      : // eslint-disable-next-line no-restricted-syntax
        null;
  } catch (error) {
    logger.error(`Unable to get localStorage - ${USERNAME_CACHE_KEY}`, error);
    // eslint-disable-next-line no-restricted-syntax
    return null;
  }
};

export const setUsername = (username: string) => {
  try {
    localStorage.setItem(USERNAME_CACHE_KEY, btoa(username));
  } catch (error) {
    logger.error(`Unable to set localStorage - ${USERNAME_CACHE_KEY}`, error);
  }
};

export const clearUsername = () => localStorage.removeItem(USERNAME_CACHE_KEY);

export const isUsernameCached = () => getUsername() !== null;
